import React from "react";
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import AdvancedSearchFilters from '../components/advancedSearchFilters'
import AdvancedSearchResults from '../components/advancedSearchResults'
import store, { history } from './store'
import { CookiesProvider } from 'react-cookie';

const App = () => {
  return (
    <section id="searchsection" className="section">
      <div className="container">
        <div className="row row-bordered">
          <div className="col-md-5">
            <AdvancedSearchFilters></AdvancedSearchFilters>
          </div>
          <div className="col-md-7">
            <AdvancedSearchResults></AdvancedSearchResults>
          </div>
        </div>
      </div>
    </section>
  );
};

let rootElement = document.querySelector("#searchAppRoot");
if(rootElement){
	render(
    <CookiesProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </CookiesProvider>,
	  rootElement
	)
}

